module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messages__container"
  }, [_c('div', {
    staticClass: "messages__content"
  }, [_c('h2', {
    staticClass: "ui inverted center aligned header"
  }, [_vm._v(_vm._s(_vm.channelName))]), _vm._v(" "), _c('div', {
    staticClass: "ui segment"
  }, [_c('div', {
    staticClass: "ui comments"
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "list"
    }
  }, _vm._l((_vm.messages), function(message) {
    return _c('single-message', {
      key: message.id,
      attrs: {
        "message": message
      }
    })
  }))], 1)])]), _vm._v(" "), _c('message-form')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64b65e76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/Messages.vue
// module id = 224
// module chunks = 1